export const testimonials = [
  {
    courseId: "1",
    label: "K12",
    subject: [
      {
        subjectId: "1",
        subJectName: "Digital SAT",
        review: [
          {
            images: "Rohan233616573.jpeg",
            name: "Rohan Chowdary",
            class: "12th",
            score: "SAT Score : (1550/1600)",
            universities: "Score 1560/1600",
            comments:
              "I studied my Grade 11th and 12th at FIITJEE, Hyderabad. I got initial counselling from EDUTECHEX and then later got enrolled into their SAT Prep Program. EDUTECHEX teachers and counselors were instrumental in getting excellent SAT results. Their assessments were extremely helpful to me. I highly recommend EDUTECHEX for SAT Prep especially if you are aiming at Ivy League universities in the US and around the world.",
          },
          {
            images: "saraya-nad232125384.jpg",
            name: "Sarayu Nadiva",
            class: "12th",
            score: "SAT Score : (1550/1600)",
            universities: "Score 1550/1600",
            comments:
              "I have a dream to study quantum physics at one of the ivy leagues in the US. EduTechEx SAT training program along with their expert counselling played a very important role in making my dream come true.",
          },
          {
            images: "simha-m232148394.jpg",
            name: "Simha Davalekar",
            class: "12th",
            score: "SAT Score : (1600/1600)",
            universities: "Score 1600/1600",
            comments:
              "My dream to become an aeronautical engineer date back to my child hood. I was extremely fortunate to be associated with EduTechEx and by taking their SAT program, I formed a solid foundation for my successful ivy league application process.",
          },
          {
            images: "sureya-f234506678.jpg",
            name: "Sureya Khan",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "Score 1580/1600",
            comments:
              "I took SAT training from different players in the market, but my score never crossed 1400. A friend of mine introduced me to EduTechEx, their innovative SAT training program not only helped me score 1580 in SAT but also through their expert counselling I was able to apply to the right universities considering my interest in media studies and journalism.",
          },
          {
            images: "bhavik-m231937743.jpg",
            name: "Bhavik P",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "SAT Physics:- 760 , SAT Mathematics:-742 , SAT Chemistry:- 790",
            comments:
              'Bhavik got admitted into BITS, Hyderabad. In his own words, "I had a dream to study Mechanical engineer which has been fulfilled by EduTechEx. Thank you for their exceptional training and services."',
          },
          {
            images: "manasa-f231857234.jpg",
            name: "Manasa V",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "SAT Physics:- 800 , SAT Biology:- 790",
            comments:
              'Manasa got admitted into UCLA for doing a Medical degree. In her own words, " The training I received at EduTechEx for SAT General and SAT EduTechEx is excellent which helped me to get into UCLA. Thank you EduTechEx."',
          },
          {
            images: "gowtham-m234032748.jpg",
            name: "Gowtham A",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "SAT General:- 1490 , SAT Physics:- 780 , SAT Mathematics:- 760",
            comments:
              'Gowtham got admitted into UC Davis. In his own words, "Thank you EduTechEx for helping me during the preparation for SAT General and SAT Subject. Your teaching, training and educational counseling was excellent which helped me to achieve my dreams."',
          },
          {
            images: "vaishanavi234052373.jpg",
            name: "Vaishnavi M",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "SAT Mathematics - 800 , SAT Physics - 790 , SAT Chemistry - 800",
            comments:
              'Vaishanvi got selected in University of California, Irvine and BITS, Hyderabad for doing Computer Science. In her own words, "EduTechEx has helped me to get in UC Irvine. I am very grateful to the management and faculty of EduTechEx."',
          },
          {
            images: "bharath-ol234142635.jpg",
            name: "Bharath S",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "SAT Mathematics - 800 , SAT Physics - 800 , SAT Chemistry - 800",
            comments:
              'Bharath got admitted into University of Florida for Computer Science degree with scholarship. In his own words, "Thank you so much to the faculty at EduTechEx for their excellent training and teaching services. It helped me a lot in understanding the concepts and achieve a good score in SAT General and SAT subject tests."',
          },
        ],
      },
      {
        subjectId: "2",
        subJectName: "Advanced Placement Tests",
        review: [
          {
            images: "parush-m234202096.jpg",
            name: "Parush G",
            class: "12th",
            comments:
              "I took AP Biology from EDUTECHEX. I am very happy with the teachers and the way classes are conducted. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "piyush-m234808403.jpg",
            name: "Piyush",
            class: "12th",
            comments:
              "My Goal was to do MBBS in the US. As part of the Ivy League program, I took AP Biology courses. I enjoyed taking the classes from EDUTECHEX and scored well in the exam. Thanks EDUTECHEX!",
            universities: "Score 4/5",
          },
          {
            images: "anil-m234824673.jpg",
            name: "Anil",
            class: "12th",
            comments:
              "Joined EDUTECHEX for AP Bio and really excited to get 5/5 in the exam. The score was very helpful during my US Bachelor's application process. Thanks to the planned and dedicated teaching at EDUTECHEX.",
            universities: "Score 5/5",
          },
          {
            images: "divya-f230421818.jpg",
            name: "Divya",
            class: "12th",
            comments:
              "I took AP Calculus AB from EDUTECHEX. I am very happy with the teachers and the way classes are conducted. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "purushotth234857240.jpg",
            name: "Purshottham",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in MIS in the US. As part of the Ivy League program, I took AP Calculus AB courses. Classes and schedule was meticulously planned. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "chandana-f234913107.jpg",
            name: "Chandana",
            class: "12th",
            comments:
              "I joined EDUTECHEX for SAT classes and ended up taking AP Calculus AB classes. AP classes also helped me to do well in my 12th Mathematics too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "charitha-f234929468.jpg",
            name: "Charitha",
            class: "12th",
            comments:
              "I took AP Calculus BC from EDUTECHEX. I am very happy with the teachers and the way classes are conducted. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "krishna-m234952265.jpg",
            name: "Krishna",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Data Analytics in the US. As part of the Ivy League program, I took AP Calculus AB courses. Classes and schedule was meticulously planned. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "suraj-m235050645.jpeg",
            name: "Suraj",
            class: "12th",
            comments:
              "I took AP Calculus BC classes from EDUTECHEX. Not only I did well in AP, the classes also helped me to do well in my 12th Mathematics too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "rohith-m235108100.jpg",
            name: "Rohith",
            class: "12th",
            comments:
              "I took AP Physics 1 from EDUTECHEX. I am very happy with the classes and the timely assessments. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "akash-m235125042.jpg",
            name: "Aakash",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Aerospace in the US. As part of the Ivy League program, I took AP Physics 1 courses. Classes and schedule was meticulously planned. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "abhiram-m235221606.jpg",
            name: "Abhiram",
            class: "12th",
            comments:
              "I took AP Physics 1 classes from EDUTECHEX. Not only I did well in AP, the classes also helped me to do well in my 11th Physics exams too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "abhijit-m235241296.jpg",
            name: "Abhijeet",
            class: "12th",
            comments:
              "I took AP Physics 2 from EDUTECHEX. I am very happy with the classes and the timely assessments. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "ashrit-m231432759.jpg",
            name: "Ashrit P",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Aerospace in the US. As part of the Ivy League program, I took AP Physics 2 courses. Classes and schedule was meticulously planned. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "yagnesh-m235352989.jpg",
            name: "Yagnesh Rao",
            class: "12th",
            comments:
              "I took AP Physics 2 classes from EDUTECHEX. Not only I did well in AP, the classes also helped me to do well in my 12th Physics exams too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "arun-m235409499.jpg",
            name: "Arun B",
            class: "12th",
            comments:
              "I took AP Physics C - Electricity and Magnetism from EDUTECHEX. I am very happy with the classes and the timely assessments. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "bharath-m235527605.jpg",
            name: "Bharath Reddy",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Aerospace in the US. As part of the Ivy League program, I took AP Physics C - Electricity and Magnetism course. Classes and schedule was meticulously planned which helped me to get the best score. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "poorensh-m235636423.jpeg",
            name: "Poornesh Chand",
            class: "12th",
            comments:
              "I took AP Physics C - Electricity and Magnetism classes from EDUTECHEX. Not only I did well in AP, the classes also helped me to do well in my 12th Physics exams too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "karan-m235653881.jpg",
            name: "Karan",
            class: "12th",
            comments:
              "I took AP Physics C - Mechanics from EDUTECHEX. I am very happy with the classes and the timely assessments. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "anvi-f235941143.jpg",
            name: "Anvi Singh",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Material Science in the US. As part of the Ivy League program, I took AP Physics C - Mechanics course. Classes and schedule was meticulously planned which helped me to get the best score. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "satish-m230216423.jpg",
            name: "Satish L",
            class: "12th",
            comments:
              "I took AP Physics C - Mechanics classes from EDUTECHEX. Not only I did well in AP exam, the classes also helped me to do well in my 12th Physics exams too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "saurabh-m230238388.jpg",
            name: "Saurabh",
            class: "12th",
            comments:
              "I took AP Chemistry from EDUTECHEX. I am very happy with the classes and the timely assessments. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "tejaswani-230344500.jpeg",
            name: "Tejaswani",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Medicine in the US. As part of the Ivy League program, I took AP Chemistry course. Classes and schedule was meticulously planned which helped me to get the best score. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "samrat-m230403152.jpg",
            name: "Samrat",
            class: "12th",
            comments:
              "I took AP Chemistry classes from EDUTECHEX. Not only I did well in AP exam, the classes also helped me to do well in my 12th Chemistry exams too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "divya-f234840823.jpg",
            name: "Divya Sree",
            class: "12th",
            comments:
              "I took AP Macroeconomics from EDUTECHEX. I am very happy with the classes and the timely assessments. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "pankaj-m230543648.jpeg",
            name: "Pankaj",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Economics in the US. As part of the Ivy League program, I took AP Macroeconomics course. Classes and schedule was meticulously planned which helped me to get the best score. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "Vishal-var231314332.jpeg",
            name: "Vishal Varma",
            class: "12th",
            comments:
              "I took AP Macroeconomics classes from EDUTECHEX. Not only I did well in AP exam, the classes also helped me to do well in my 12th Board exams too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
          {
            images: "aman-m231331352.jpg",
            name: "Aman Sharma",
            class: "12th",
            comments:
              "I took AP Microeconomics from EDUTECHEX. I am very happy with the classes and the timely assessments. I attribute scoring 5/5 to EDUTECHEX teaching methodology!",
            universities: "Score 5/5",
          },
          {
            images: "akshay-m231358135.jpg",
            name: "Akshay V",
            class: "12th",
            comments:
              "My Goal was to do Bachelors in Economics in the US. As part of the Ivy League program, I took AP Microeconomics course. Classes and schedule was meticulously planned which helped me to get the best score. Thanks to EDUTECHEX!",
            universities: "Score 5/5",
          },
          {
            images: "venkat-rao231418519.jpeg",
            name: "Venkat Rao",
            class: "12th",
            comments:
              "I took AP Microeconomics classes from EDUTECHEX. Not only I did well in AP exam, the classes also helped me to do well in my 12th Board exams too. Overall very happy with the program.",
            universities: "Score 4/5",
          },
        ],
      },
      {
        subjectId: "3",
        subJectName: "Ivy League Program",
        review: [
          {
            images: "Karthik-Re231656522.jpeg",
            name: "Karthik Reddy",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "Baylor University, University of Texas – Dallas",
            comments:
              "I joined EDUTECHEX Ivy League Program and really impressed with the program. The program really helped with the application and admission process and realized my dream to pursue computer science at my dream universities. Thank you EDUTECHEX!",
          },
          {
            images: "Krish-Meht231536278.png",
            name: "Krish Mehta",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities:
              "General Engineering - Texas A&M College Station, Electrical Engineering with Scholarship – ASU, Buffalo State University with USD 50,000 Scholarship, Stony Brook University with Scholarship",
            comments:
              "Studying bachelor's in electrical engineering at the top universities in the US is my dream. Through EDUTECHEX Ivy league program, I am able to realize my dream. Thanks for the excellent training and guidance received from EDUTECHEX counsellors.",
          },
          {
            images: "Ritvik-Red231804724.jpg",
            name: "Ritvik Reddy",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "BS in Computer Science, Fulton School of Engineering, ASU, Tempe",
            comments:
              "Computer Science has always been my passion. Initially my plan was to study in India, later through EDUTECHEX Ivy league program I came to know about the excellent opportunities for doing bachelors in the US. Thanks, EDUTECHEX for helping me through the entire application process.",
          },
          {
            images: "Sriram-Par231831173.jpeg",
            name: "Sriram Parsi",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "BS, University of Minnesota, USA",
            comments:
              "EDUTECHEX Ivy League Program has been wonderfully designed to assist students through the entire abroad application process. I thank EDUTECHEX teachers and counsellors for the outstanding support.",
          },
          {
            images: "Purvika231639956.jpg",
            name: "Purvika Reddy",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities:
              "BS at Denison University with USD 80,000 Scholarship, University of Delaware, Arizona State University, Ohio University",
            comments:
              "EDUTECHEX Ivy League Program has helped me immensely through the entire US application process. I thank EDUTECHEX teachers and counsellors for the outstanding support for SAT, APs and University Placements Program.",
          },
          {
            images: "Chinmay-Va231554061.jpeg",
            name: "Chinmay Vasisht",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "College of Engineering and Applied Science, Stony Brook University with Scholarship",
            comments:
              "I studied my Grade 11th and 12th at Delhi Public School, Bangalore South. I came across EDUTECHEX through a counselling session and then later got enrolled into their Ivy League Program. The entire experience was excellent, I got training for SAT, APs and also was able to do Internships from Columbia University. I highly recommend EDUTECHEX programs to aspiring students who wanted to study in the top US universities.",
          },
          {
            images: "Aryan-Kuma231320617.jpeg",
            name: "Aryan Kumar",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "University of North Carolina, Chapel Hill & University of Minnesota",
            comments:
              "I studied my Grade 11th and Grade 12th from DPS Gachibowli, Hyderabad. My passion is in computer science and always wanted to do bachelor's at the top universities in the US. EDUTECHEX Ivy League Prep helped me a lot during the preparation for SAT, APs and university application procedure. I am grateful the excellent and committed teachers and counsellors at EDUTECHEX. Thank you EDUTECHEX!",
          },
          {
            images: "manasa-f231857234.jpg",
            name: "Manasa V",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "UC, Los Angeles",
            comments:
              "Manasa got admitted into UCLA for doing a Medical degree. The training I received at EduTechEx for SAT General and SAT Subject is excellent which helped me to get into UCLA. Thank you EduTechEx.",
          },
          {
            images: "gowtham-m234032748.jpg",
            name: "Gowtham A",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "UC Davis and San Diego",
            comments:
              "Gowtham got admitted into UC Davis. Thank you EduTechEx for helping me during the preparation for SAT General and SAT Subject. Your teaching, training and educational counseling was excellent which helped me to achieve my dreams.",
          },
          {
            images: "bhavik-m231937743.jpg",
            name: "Bhavik P",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "IIIT and BITS, Hyderabad",
            comments:
              "Bhavik got admitted into BITS, Hyderabad. I had a dream to study Mechanical engineer which has been fulfilled by EduTechEx. Thank you for their exceptional training and services.",
          },
          {
            images: "vaishanavi234052373.jpg",
            name: "Vaishnavi M",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "UC, Irvine and BITS, Hyderabad",
            comments:
              "Vaishanvi got selected in University of California, Irvine and BITS, Hyderabad for doing Computer Science. EduTechEx has helped me to get in UC Irvine. I am very grateful to the management and faculty of EduTechEx.",
          },
          {
            images: "bharath-ol234142635.jpg",
            name: "Bharath S",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "University of Florida (Gainesville), IIIT Hyderabad, BITS Hyderabad",
            comments:
              "Bharath got admitted into University of Florida for Computer Science degree with scholarship. Thank you so much to the faculty at EduTechEx for their excellent training and teaching services. It helped me a lot in understanding the concepts and achieve a good score in SAT General and SAT subject tests.",
          },
          {
            images: "Sarayu-Goo232434651.jpeg",
            name: "Sarayu Nadiva",
            class: "12th",
            score: "SAT Score : (1550/1600)",
            universities: "Bachelor's in Mechanical Engineering, California Institute of Technology, USA",
            comments:
              "Thanks to the excellent guidance and training from EDUTECHEX. I took the Ivy league program which included SAT and AP Prep, Internships, and university placement program. My entire application has been meticulously planned and I got admitted into more than five top universities in USA.",
          },
          {
            images: "simha-m232148394.jpg",
            name: "Simha Davalekar",
            class: "12th",
            score: "SAT Score : (1600/1600)",
            universities: "Bachelor's in Aerospace, Georgia Institute of Technology, USA",
            comments:
              "The entire Ivy League program at EDUTECHEX has been so well planned. I started my program in the beginning of 11th Grade and got the best scores in SAT and Advanced Placement Tests. My internships were excellently planned with a blend of program curated at top universities and industry. Thanks for making my dream possible. Kudos to Team EDUTECHEX!",
          },
          {
            images: "sureya-f234506678.jpg",
            name: "Sureya Khan",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "Bachelor's in Literature, Princeton, USA",
            comments:
              "My dream was to study Literature at Princeton. Before joining EDUTECHEX, I thought its very unrealistic, joining EDUTECHEX Ivy League program provided me a clinical pathway for the preparation of SAT and APs and helped me to get successful admissions into the Ivy leagues.",
          },
          {
            images: "akshita-f232237146.jpg",
            name: "Akshita",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "Bachelor's Degree, Savannah College of Art and Design",
            comments:
              "My friend referred me to EDUTECHEX Ivy League Program. I initially started with the AP program and later got enrolled to SAT, Internship and University Placements Program. I attribute all my successful admissions to EDUTECHEX programs and their meticulous planning and guidance!",
          },
          {
            images: "jain-manas232256049.jpg",
            name: "Jain Manas",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "BBA, University of Cincinnati, USA",
            comments:
              "My journey with EDUTECHEX through the entire Ivy League Program has been very wonderful. I owe my success to EDUTECHEX counsellors, teachers and mentors who helped me in the entire process. Thank you EDUTECHEX!",
          },
          {
            images: "rithika-f232322426.jpg",
            name: "Rithika",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "College of Liberal Arts and Science, University of Kansas, USA",
            comments:
              "Thanks you so much EDUTECHEX for helping me through the entire SAT, AP and university placement program and helping me to pursue my dream course!",
          },
          {
            images: "Sarayu-Goo232434651.jpeg",
            name: "Sarayu Goorisetti",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "Bachelors in Business Law, Arizona State University",
            comments:
              "Initially I was very hesitant to take AP test preparation. EDUTECHEX career navigation program combined with ivy league program has been instrumental in planning my bachelor studies in the US.",
          },
          {
            images: "shravan-m232531704.jpg",
            name: "Shravan Karande",
            class: "12th",
            score: "SAT Score : (1580/1600)",
            universities: "Bachelors in Computer Science, ASU, USA",
            comments:
              "Thanks to excellent support and guidance provided by EDUTECHEX. I took University Placement program from EDUTECHEX, the program was excellently planned to support my application.",
          },
          {
           
  images: "Ritvik-Red231804724.jpg",
  name: "Ritwik Reddy",
  class: "12th",
  score: "SAT Score : (1580/1600)",
  universities: "Bachelor's in Computer Game Programming, Rochester Institute of Technology",
  comments:
    "I am always passionate about gaming technologies. I was not sure how to map it to a bachelor's degree program in the US. EDUTECHEX Ivy league program not only helped me to get the top scores in the aptitude test but also able to map my passion to relevant course. Thanks to EDUTECHEX!",
}
        ],
      },
      {
        subjectId: "4",
        subJectName: "Medical Program",
        review: [
          {
            images: "aryaan-m232802721.jpg",
            name: "Aryaan Chandool",
            universities:
              "All India Institute of Medical Sciences (AIIMS)\nPost Graduate Institute of Medical Education and Research (PGIMER)",
            comments:
              "I have a dream to study medicine at one of the premier schools in India. EduTechEx NEET training program along with their expert counselling played a very important role in making my dream come true.",
          },
          {
            images: "viven-m232819545.jpg",
            name: "Viven Prachlen",
            universities:
              "Christian Medical College (CMC),\nNational Institute of Mental Health & Neuro Sciences (NIMHANS)",
            comments:
              "My dream is to study radiology and imaging at a prestigious medical school. I was extremely fortunate to be associated with EduTechEx and by taking their NEET program, I formed a solid foundation for my successful admission process.",
          },
          {
            images: "Sumit-K-m232925880.jpeg",
            name: "Sumit K",
            universities: "IMS - Banaras Hindu University & JIPMER",
            comments:
              "I took NEET online training from different players in the market, but my score never crossed 550. A friend of mine introduced me to EduTechEx, their innovative NEET training program not only helped me score 700 in NEET but also through their expert counselling I was able to apply to the right universities considering my interest in medicine especially neurosciences.",
          },
          {
            images: "Ushodaya-Y233045069.jpeg",
            name: "Ushodaya Y",
            universities: "KMC Manipal & Madras Medical College (MMC)",
            comments:
              "Its my dream to get into the top medical schools in India to study advanced surgery. EduTechEx NEET program helped to get score well in the test. Their well-designed curriculum and training, especially the timely assessments helped me a lot. Kudos to Team EduTechEx for making my dream come true.",
          },
          {
            images: "suresh-m233103410.jpg",
            name: "Suresh",
            universities: "Bachelors in Medicine, University of Cambridge, UK",
            comments:
              "I joined EDUTECHEX MBBS Program through which I got very helpful guidance and training for BMAT and UCAT. The entire application process has been planned in a meticulous manner. Thanks EDUTECHEX!",
          },
          {
            images: "ankita-f233119464.jpg",
            name: "Ankita",
            universities: "BSc (Medicine), University of St Andrews, UK",
            comments:
              "I always knew doing medicine in the UK is very competitive. EDUTECHEX Medical Training program not only helped me to shortlist the right universities but also to have a successful application to the top colleges in UK.",
          },
          {
            images: "philip-m233135620.jpg",
            name: "Philip",
            universities: "MBChB Medicine, University of Edinburgh, UK",
            comments:
              "I'm extremely happy to get admitted to Edinburgh medical school. I thank EDUTECHEX for their innovative medical navigation program through which I greatly benefitted both in terms of counselling and training.",
          },
          {
            images: "harini-f233151647.jpg",
            name: "Harini",
            universities: "Pre-Med Program, Yale University, USA",
            comments:
              "I took Pre-Med Ivy League training program from EDUTECHEX. The program was very helpful for me and EDUTECHEX is also helping me for MCAT training.",
          },
          {
            images: "zoyan-m233206521.jpg",
            name: "Zoyan",
            universities: "Pre-Med Program, Kansas University, USA",
            comments:
              "As part of the Pre-Med program, I took SAT and APs training from EDUTECHEX. EDUTECHEX training coupled with excellent guidance help me to get admitted into the top universities in the US.",
          },
          {
            images: "likesh-m233220317.jpg",
            name: "Likesh",
            universities: "Pre-Med Program, University of California- San Francisco, USA",
            comments:
              "Thanks to EDUTECHEX for getting me admitted to UC-SF for the pre-med program. The program helped me to get very broad insights to the specializations in the field of medical and helped me to plan my application to the top medical schools.",
          },
        ],
      },
      {
        subjectId: "5",
        subJectName: "Indian Entrance Prep",
        review: [
          {
            images: "nandhan-m233235579.jpg",
            name: "Nandhan K",
            class: "Graduation",
            comments:
              "My goal was to study computer science at IIT Kanpur. EDUTECHEX integrated JEE prep course has helped to strengthen my concepts and do well in JEE Mains and Advanced exams. Thanks to EDUTECHEX for the wonderful training provided.",
            universities: "IIT Kanpur",
          },
          {
            images: "deepak-m233248897.jpg",
            name: "Deepak B",
            class: "Graduation",
            comments:
              "I was always passionate about doing Mechanical engineering at IIT Madras. EDUTECHEX JEE navigation programs has not only helped me to do well in the JEE exam but also gave me a deep understanding into the specializations offered with the departments.",
            universities: "IIT Madras",
          },
          {
            images: "santosh-m233304935.jpg",
            name: "Santosh V",
            class: "Graduation",
            comments:
              "Doing Aerospace has been my innate interest since my schooling. EDUTECHEX JEE program has helped me to extremely well in the JEE program and helped me join Aerospace Engineering at IIT Kharagpur. Thanks to the excellent training received at EDUTECHEX.",
            universities: "IIT Kharagpur",
          },
          {
            images: "rajesh-m233333208.jpg",
            name: "Rajesh Chandra",
            class: "Graduation",
            comments:
              "At EDUTECHEX, I got excellent training for BITSAT program. Teachers are available all the time to help me in any doubts in concepts. The integrated also helped me to do well in curriculum classes.",
            universities: "BITSAT Program",
          },
          {
            images: "Dheeraj-Sh233429584.jpeg",
            name: "Dheeraj Shukla",
            class: "Graduation",
            comments:
              "I attribute my success in the BITSAT exam to the well-structured training program at EDUTECHEX. Teachers gave us ample attention and the assessments were scheduled systematically for me to score well in the mock tests and the main exam.",
            universities: "BITSAT Program",
          },
          {
            images: "sagar-m233447609.jpg",
            name: "Sagar Anand",
            class: "Graduation",
            comments:
              "Doing Integrated program in Physics at BITS PILANI has been my interest since college. EDUTECHEX BITSAT program has helped me to extremely well in the exam. Thanks to the excellent training received at EDUTECHEX.",
            universities: "BITSAT Program",
          },
          {
            images: "bhargav-m233509805.jpg",
            name: "Bhargava M",
            class: "Graduation",
            comments:
              "My goal was to study LAW at Nalsar Hyderabad. EDUTECHEX integrated CLAT prep course has helped to strengthen my concepts and do well in the exams. Thanks to EDUTECHEX for the wonderful training provided.",
            universities: "CLAT Program",
          },
          {
            images: "divya-f234840823.jpg",
            name: "Divya Madhuri",
            class: "Graduation",
            comments:
              "I was always passionate about doing LAW at NLSIU Bangalore. EDUTECHEX LAW navigation programs has not only helped me to do well in the CLAT exam but also gave me a deep understanding into the specializations offered with the departments.",
            universities: "CLAT Program",
          },
          {
            images: "thanesh-m233545032.jpg",
            name: "Thanesh Malhotra",
            class: "Graduation",
            comments:
              "Doing Integrated LAW program has been my innate interest since my schooling. EDUTECHEX CLAT program has helped me to extremely well in CLAT and LSAT and helped me join National Academy of Legal Studies and Research University. Thanks to the excellent training received at EDUTECHEX.",
            universities: "CLAT Program",
          },
        ],
      },
      {
        subjectId: "6",
        subJectName: "Career Navigation",
        review: [
          {
            images: "rohith-m235108100.jpg",
            name: "Rohit Varma",
            class: "12th Grade",
            comments:
              "I took EDUTECHEX Navigation program from my 10th Grade onwards. The program has been meticulously planned from identifying my personality and suggesting the relevant the stream and subjects for my IBDP curriculum. In addition, I also got enrolled into the Ivy League program through which I am getting the relevant training for aptitude tests, internships and university placements.",
            universities: "IBDP",
          },
          {
            images: "Priya-Rama233654609.jpeg",
            name: "Priya Raman",
            class: "Aerospace Engineering, 1st year",
            comments:
              "Before joining EDUTECHEX Navigation program, I was planning to prepare only for Indian entrance exams which are very stressful. Through the Navigation program, I not only identified my strengths and weaknesses but also was also able to go through a successful ivy league admission and got admitted into my dream career Aerospace engineering.",
            universities: "Caltech, USA",
          },
          {
            images: "rajesh-pra233713873.jpg",
            name: "Rajesh Prasad",
            class: "11th Grade",
            comments:
              "My passion was always in English literature but I always had tough time convincing my parents on this. It is only through EDUTECHEX Navigation Program, my parents got convinced on my passion and allowed me to choose the right combination of subject in my college. The amazing part of this program is getting access to global career preparatory programs which aligned my passion to the relevant universities and courses.",
            universities: "AS & A Levels - Cambridge",
          },
        ],
      },
      {
        subjectId: "7",
        subJectName: "After School Services",
        review: [
          {
            images: "Rajneesh-M233818227.jpeg",
            name: "Rajneesh Mishra",
            class: "Grade 9",
            universities: "Grade 9, CBSE Board",
            comments:
              "EDUTECHEX student Rajneesh scored 99% in CBSE 9th Board, scoring excellent marks in Math, Science and English subjects. Rajneesh credits his success to EDUTECHEX way of teaching and guidance received throughout the program.",
          },
          {
            images: "aradhya-f233837185.jpg",
            name: "Aradhya Reddy",
            class: "Grade 9",
            universities: "Grade 9, ICSE Board",
            comments:
              "Aradhya took EDUTECHEX after school program and achieved 99.4% percent in ICSE final exams. The in-depth program developed by EDUTECHEX has been very helpful to focus on foundations of the topics which helped me do well in the exams.",
          },
          {
            images: "hafeefa-f234412987.jpg",
            name: "Hafeefa N",
            class: "Grade 9",
            universities: "Grade 9, State Board",
            comments:
              "Hafeefa completed her 9th Grade from State Syllabus and celebrated getting highest grade in her final exams. She got enrolled in the After School Program which also helped her to crack various Olympiad exams too. Hafeefa thanks EDUTECHEX for helping her achieve this academic milestone.",
          },
          {
            images: "madhav-m234430342.jpg",
            name: "Madhav R",
            universities: "Grade 10, CBSE Board",
            comments:
              "EDUTECHEX student Madhav scored 99% in CBSE 10th Board, scoring excellent marks in Math, Science and English subjects. He credits his success to EDUTECHEX way of teaching and guidance received throughout the program.",
          },
          {
            images: "Rajasekhar234533265.jpg",
            name: "Rajasekhar A",
            universities: "Grade 10, ICSE Board",
            comments:
              "Rajasekhar took EDUTECHEX after school program and achieved 99.4% percent in ICSE final exams. The in-depth program developed by EDUTECHEX has been very helpful to focus on foundations of the topics which helped me do well in the exams.",
          },
          {
            images: "Nilesh-Pra234628153.jpeg",
            name: "Nilesh Prasad",
            universities: "Grade 10, State Board",
            comments:
              "Nilesh completed his 10th Grade from State Syllabus and achieved highest grade in his final exams. Our After School Program also helped Nilesh to crack various Olympiad exams too. Thanks to EDUTECHEX for helping me navigate through this entire journey.",
          },
          {
            images: "ayush-kish234745166.jpg",
            name: "Aayush Kishan",
            universities: "Grade 11, CBSE Board",
            comments:
              "EDUTECHEX after school program for 11th Grade was very helpful to me in clearing my doubts in Math, Physics and Chemistry which were otherwise extremely complicated and difficult. EDUTECHEX teachers made it simple and very lively.",
          },
          {
            images: "vaibhav-m234828831.jpg",
            name: "Vaibhav Gupta",
            universities: "Grade 11, ICSE Board",
            comments:
              "Vaibhav took EDUTECHEX after school program and achieved 99.4% percent in his final exams. The in-depth program developed by EDUTECHEX has been very helpful to focus on foundations of the topics which helped me do well in the exams.",
          },
          {
            images: "anjun-m234726630.jpg",
            name: "Anjun Khanna",
            universities: "Grade 11, State Board",
            comments:
              "Anjun completed his 11th Grade from State Board and achieved highest grade in his final exams. Our After School Program also helped Anjun to scientifically remember the topics without memorizing them. The program proved very important.",
          },
          {
            images: "ayush-kish234745166.jpg",
            name: "Aayush Kishan",
            universities: "Grade 11 & 12, CBSE",
            comments:
              "EDUTECHEX after school program for 11th and 12th Grade was very helpful to me in clearing my doubts in Math, Physics and Chemistry which were otherwise extremely complicated and difficult. EDUTECHEX teachers made it simple and very lively.",
          },
          {
            images: "vaibhav-m234711202.jpg",
            name: "Vaibhav Gupta",
            universities: "Grade 11 & 12, ICSE",
            comments:
              "Vaibhav took EDUTECHEX after school program for 11th and 12th and achieved 99.4% percent in his final exams. The in-depth program developed by EDUTECHEX has been very helpful to focus on foundations of the topics which helped me do well in the exams.",
          },
          {
            images: "anjun-m234726630.jpg",
            name: "Anjun Khanna",
            universities: "Grade 11 & 12, State Board",
            comments:
              "Anjun completed his 11th Grade and 12th Grade from State Board and achieved highest grade in his final exams. Our After School Program also helped Anjun to scientifically remember the topics without memorizing them. The program proved very important.",
          },
          {
            images: "Gunakshi-f235142567.jpeg",
            name: "Gunakshi",
            comments:
              "We took IGCSE Integrated after school program for our daughter from EDUTECHEX. Their teachers are experts in subject teaching and very organized in dealing with the syllabus. My daughter not only did well in school exams but also her confidence and knowledge also improved quite a lot. We highly recommend EDUTECHEX IGCSE after school program.",
            universities: "Grade 9, Cambridge IGCSE",
          },
          {
            images: "lohith-m235159479.jpg",
            name: "Lohith",
            comments:
              "Our son had lot of challenges in coping up Science and Math in MYP at School. We learned about EDUTECHEX After School Program through our colleagues. Since we enrolled our son into the program, he grades consistently improved and he started enjoying math and science learning ever than before. Very beneficial program for students!",
            universities: "Grade 9, IB-MYP",
          },
          {
            images: "sujith-m235215110.jpg",
            name: "Sujith and Slokha",
            comments:
              "We joined both our son and daughter into EDUTECHEX after school program. Apart from doing well in Science, Math and English, both our children got access to EDUTECHEX Navigation Program through which they discovered their passionate careers and focusing on ivy league preparation along with the after-school program.",
            universities: "Grade 9, Cambridge IGCSE & IB-MYP",
          },
          {
            images: "Jeevana235312674.jpeg",
            name: "Jeevana",
            comments:
              "EDUTECHEX after school program has been played a very important role in strengthening the foundation of science and math for our daughter. EDUTECHEX not only focused on math, science and English, they also focused on personality aspect which also boosted my daughter's confidence. I highly recommend the program to students.",
            universities: "Grade 10, Cambridge IGCSE",
          },
          {
            images: "mahesh-m235327225.jpg",
            name: "Mahesh",
            comments:
              "We joined our son in EDUTECHEX after school program after taking their demo classes in math, science and English. The classes were very interactive, and teachers are well qualified and encourage students to ask questions in the classes. Overall, our son enjoyed the entire learning process with EDUTECHEX.",
            universities: "Grade 10, IB-MYP",
          },
          {
            images: "Saroor235419720.jpeg",
            name: "Saroor",
            comments:
              "Getting qualified teachers for IGCSE tutoring always has been a challenge for us. We were very fortunate to come across EDUTECHEX after school program, our son improved in various aspects after taking the program. The classes also increased his self-confidence and analytical abilities, focus and concentration while studying. Excellently curated program for students.",
            universities: "Grade 10, Cambridge IGCSE",
          },
          {
            images: "aneesh-f235634017.jpg",
            name: "Aneesh M",
            comments:
              "EDUTECHEX after school program for AS & A levels has helped me a lot to do well in my school subject. In addition, I got great help for my career navigation and competitive exam preparation too. I highly recommend the program to students.",
            universities: "Grade 11, Cambridge AS & A Levels",
          },
          {
            images: "raghavendr235651232.jpg",
            name: "Raghavendra J",
            comments:
              "For our son, navigating through Math and Science in IBDP has been extremely challenging. EDUTECHEX after school program made him do well in his IBDP and strengthened his concepts. Overall, our son enjoyed the entire learning process with EDUTECHEX.",
            universities: "Grade 11, IBDP",
          },
          {
            images: "ramya-f235721200.jpg",
            name: "Ramya P",
            comments:
              "My goal is to get into the Ivy League universities in the US for which having good scores in my IBDP is very important. EDUTECHEX IBDP after school program has really helped me not only to improve my scores but also helped me to get clarity on the majors, I wanted to pursue in Bachelors. Excellently curated program for students.",
            universities: "Grade 11, IBDP",
          },
          {
            images: "aneesh-f235439358.jpg",
            name: "Aneesh M",
            comments:
              "EDUTECHEX after school program for AS & A levels has helped me a lot to do good in Math, Science and English. In addition, I got great help for my career navigation, SAT, and Advanced Placement Test preparation too. I highly recommend the program to students.",
            universities: "Grade 12, Cambridge AS & A Levels",
          },
          {
            images: "raghavendr235542438.jpg",
            name: "Raghavendra J",
            comments:
              "EDUTECHEX after school program has been well curated with the right blend of teaching classes and assessments. I enjoyed the entire learning process with EDUTECHEX.",
            universities: "Grade 12, Cambridge AS & A levels",
          },
          {
            images: "ramya-f235559497.jpg",
            name: "Ramya P",
            comments:
              "My goal is to get into the Ivy League universities in the US for which having good scores in my IBDP is very important. EDUTECHEX IBDP after school program has really helped me not only to improve my scores but also helped me to get clarity on the majors, I wanted to pursue in Bachelors. Excellently curated program for students.",
            universities: "Grade 12, IBDP",
          },
        ],
      },
    ],
  },
  {
    courseId: "2",
    label: "Undergraduate",
    subject: [
      {
        subjectId: "1",
        subJectName: "Abroad Masters",
        review: [
          {
            images: "venkata-sa235738445.jpg",
            name: "Venkata Sai Krishna K",
            comments:
              "My passion was do cybersecurity. EDUTECHEX Master's program helped me to pursue my passionate degree at a top university in the US. The entire program is planned meticulously and executed with perfection. I highly recommend this program!",
            class: "Masters, Cybersecurity",
            universities: "Masters, Cybersecurity, NYU Tandon School of Engineering, USA",
          },
          {
            images: "Ganesh-A230044167.jpeg",
            name: "Ganesh A",
            comments:
              "My experience with EDUTECHEX Masters program has been quite good. Through EDUTECHEX, I got all the required training programs for my application procedure. EDUTECHEX guides you through the entire program hassle free through their expert teachers and counselling advice. I extremely benefited from their navigation model.",
            class: "Masters, Mechanical Engineering",
            universities: "Masters, Mechanical Engineering, Yale, USA",
          },
          {
            images: "Sara-Prasa230212952.jpg",
            name: "Sara Prasad",
            comments:
              "By end of my bachelors, I was very clear to pursue MBA from top B-Schools in India. Initially I was preparing to get into IIMs. During the process, I got to know about EDUTECHEX Master Abroad Program which helped me to plan my B-School preparatory procedure for colleges in USA and UK. Through EDUTECHEX program, I came to know the top global business schools and worked on the admission process through their expert guidance. I am extremely happy with the program outcomes. Thanks to team EDUTECHEX.",
            class: "MBA",
            universities: "MBA, University of Pennsylvania, USA",
          },
        ],
      },
      {
        subjectId: "2",
        subJectName: "Abroad Transfer",
        review: [
          {
            images: "Arjun-R230344158.jpeg",
            name: "Arjun R",
            comments:
              "My passion was do mechanical engineering. Due to the entrance stress and counselling complications in India I was not able to get admission into mechanical stream. EDUTECHEX Transfer program gave me a second chance to pursue my passionate degree at an Ivy league university in the US. The entire program is planned meticulously and executed with perfection. I highly recommend this program!",
            class: "2nd Year, Mechanical Engineering",
            universities: "Yale University, USA",
          },
          {
            images: "Chaitanya-230444016.jpeg",
            name: "Chaitanya B",
            comments:
              "I gave up on my aerospace passion when I didn't qualify JEE Mains and Advanced. Even in the private institutions, lack of proper infrastructure demotivated me from joining any aerospace courses in India. I was fortunate enough to be referred to EDUTECHEX Transfer Program, through which I not only improved my analytical and reasoning skills but was able to go through a successful ivy league admission with scholarship into my dream course in US. Kudos to Team EDUTECHEX for their innovative navigation program.",
            class: "3rd Year, Aerospace Engineering",
            universities: "Georgia Tech, USA",
          },
          {
            images: "Bharath-L230532558.jpg",
            name: "Bharath L",
            comments:
              "Business Studies has always been my course of interest for career building. I was not aware of the institution quality when I joined 1st year BBA in a top B-school in India. Through EDUTECHEX Transfer program, I came to know the top global business schools and worked on the admission process through their expert guidance. Getting admission into a top school in the US and pursuing education not only changed my world view but also enhanced my learning experience by 10x. Thanks to team EDUTECHEX.",
            class: "2nd Year BBA",
            universities: "University of Pennsylvania, USA",
          },
        ],
      },
    ],
  },
  {
    courseId: "3",
    label: "Postgraduate",
    subject: [
      {
        subjectId: "1",
        subJectName: "Abroad Ph.D.",
        review: [
          {
            images: "suresh-m230618322.jpg",
            name: "Suresh Y",
            comments:
              "My passion was do PhD in Material Science. EDUTECHEX PhD program helped me to get admitted to my passionate degree at a top university in the US. The entire program is planned meticulously and executed with perfection. I highly recommend this program!",
            class: "Doctoral Studies, Physics & Material Sciences",
            universities: "University of California - Berkeley, USA",
          },
          {
            images: "Ganesh-A230044167.jpeg",
            name: "Ganesh A",
            comments:
              "My experience with EDUTECHEX Doctoral program has been very satisfying. Through EDUTECHEX, I got all the required assistance for my application procedure. EDUTECHEX guided me through the entire program hassle free through their expert counsellors. The program helped me to secure admission at top universities to pursue doctoral studies in computer science.",
            class: "Doctoral Research, Computer Science",
            universities: "Cornell, USA",
          },
          {
            images: "subhas233416250.jpg",
            name: "Subhash R",
            comments:
              "After my Masters, my goal was to pursue Ph.D. in operations research at a top global university. During the process of exploration on the web, I got to know about EDUTECHEX PhD Abroad Program which provided me the entire navigation and direction for my application procedure. Through EDUTECHEX program, I came to know the top global universities and worked on the admission process through their expert guidance. I am extremely happy with the program outcomes. Thanks to team EDUTECHEX!",
            class: "Doctoral Studies, Operations Research",
            universities: "Carnegie Mellon, USA",
          },
        ],
      },
    ],
  },
];